import { render } from "./ChatBotM3.vue.ts?vue&type=template&id=017de01a&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotM3.vue?vue&type=template&id=017de01a&ts=true"
import script from "./ChatBotM3.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotM3.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatBotM3.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotM3.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/chatbot/ChatBotM3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "017de01a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('017de01a', __exports__)) {
    api.reload('017de01a', __exports__)
  }
  
  module.hot.accept("./ChatBotM3.vue.ts?vue&type=template&id=017de01a&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBotM3.vue?vue&type=template&id=017de01a&ts=true", () => {
    api.rerender('017de01a', render)
  })

}


export default __exports__